import { isFunction } from "@thi.ng/checks/is-function";
import { isIterable } from "@thi.ng/checks/is-iterable";
import { iterator1 } from "./iterator.js";
import { map } from "./map.js";
function labeled(id, src) {
  return isIterable(src) ? iterator1(labeled(id), src) : map(isFunction(id) ? (x) => [id(x), x] : (x) => [id, x]);
}
export {
  labeled
};
